import { css } from "styled-components";
import { MEDIA_DESKTOP } from "../../helpers/theme";

const HorizontalSectionLines = (color = "#012604") => css`
  position: relative;
  z-index: 8;
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: -100vw;
    right: -100vw;
    height: 1px;
    background: ${color};
    pointer-events: none;
  }

  /* upper grid line */
  &::before {
    top: 10%;
    transform-origin: top;
  }

  /* lower grid line */
  &::after {
    bottom: 10%;
    transform-origin: bottom;
  }

  ${MEDIA_DESKTOP} {
    &::before {
      top: 10%;
    }

    &::after {
      bottom: 10%;
    }
  }
`;

export default HorizontalSectionLines;
